import React, { Fragment, useState } from 'react';
import inActive from 'Assets/img/svg/budges/inActive.svg';
import scissor from 'Assets/img/svg/icons/scissors.svg';
import time from 'Assets/img/svg/icons/time.svg';
import flower from 'Assets/img/svg/icons/flower.svg';
import { CommonButtonTypes } from 'Common/Types/Types';
import { useStyles } from './cards.style';
import { Link } from 'react-router-dom';
import { changeIdentities, minuteConversion } from 'Helpers';
import { useSelector } from 'react-redux'
import { RootState } from 'ReduxStore/store';
interface CalendarCardProps extends CommonButtonTypes {
	test?: any;
	exercise?: any;
}
const CalendarCard = ({ common, exercise }: CalendarCardProps) => {
	const classes = useStyles({ common });

	const children = useSelector((state: RootState) => state.children.children);
	const childName = localStorage.getItem('currentChild');
	const getChildId = JSON.parse(localStorage.getItem('currentChildId') || '{}');
	const child = children && children.find(child => child.id === parseInt(getChildId));
	return (
		<Fragment>
			<section className={`${classes.calendarBGOne} d-flex flex-nowrap justify-content-between py-2`}>
				<p style={{ padding: '0 1rem', color: 'white' }}>{exercise && changeIdentities(exercise.title,childName) }</p>
				<img src={inActive} alt="" className={classes.budgeCalendar} />
			</section>
			<section className={`${classes.calendarBGTwo} d-flex flex-nowrap justify-content-between`}>
				<section className="d-flex flex-nowrap">
					<div className="d-flex flex-column" style={{ padding: '0 .5rem' }}>
						<div className="d-flex flex-nowrap">
							<Link style={{textDecoration:'none'}} to={`/exercise/${exercise.id}`}>
								<img src={scissor} alt="" />{' '}
								<span className={classes.calendarCardText}>
									{exercise && exercise.DevelopmentCategory?.title}
								</span>
							</Link>
						</div>
						<div className="d-flex flex-nowrap">
							{/* <img src={flower} alt="" />{' '} */}
							{/* <span className={classes.calendarCardText}>{exercise && exercise.supplies}</span> */}
						</div>
						<div className="d-flex flex-nowrap">
							<img src={time} alt="" />{' '}
							<span className={classes.calendarCardText}>
								{exercise && minuteConversion(exercise.minutes)} mins
							</span>
						</div>
					</div>
					<div>
						<ul className={`${classes.listStyle} d-flex flex-nowrap mt-4 `}>
							{exercise.days.map((day: any, i: any) => (
								<li key={i} className={`${day.active ? classes.activeDate : classes.inActiveDate} rounded`}>
									{day.day}
								</li>
							))}
						</ul>
					</div>
				</section>
			</section>
		</Fragment>
	);
};

export default CalendarCard;
